import Vue from 'vue';
export default Vue.extend({
    name: 'CategoryCard',
    props: {
        category: { type: String, required: true },
        sessionCount: { type: Number, default: 0 },
        // Data attribute for navigation/highlighting
        dataCategoryKey: { type: String, default: '' },
        // ✅ NEW: Initial expanded state from user preferences
        initialExpanded: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            expanded: this.initialExpanded // Use prop value (defaults to false)
        };
    },
    watch: {
        initialExpanded(newVal) {
            this.expanded = newVal;
        }
    },
    methods: {
        handleExpandToggle() {
            this.expanded = !this.expanded;
            console.debug('[CategoryCard] Toggled category expansion:', {
                category: this.category,
                expanded: this.expanded
            });
            this.$emit('expand-toggled', {
                category: this.category,
                expanded: this.expanded
            });
        }
    }
});
